import { ResourceBaseTreeCore } from './Core'
import { ResourceBaseTreeProps } from './interface'
import { ResourceBaseTreeStoreProvider } from './Store'

export const ResourceBaseTree = ({
  /* -------------------------------------------------------------------------- */
  /*                       ResourceBaseTreeStoreProvider Props                      */
  /* -------------------------------------------------------------------------- */
  defaultExpandAll,
  data,

  /* -------------------------------------------------------------------------- */
  /*                           ResourceBaseTreeCore Props                           */
  /* -------------------------------------------------------------------------- */
  ...treeCoreProps
}: ResourceBaseTreeProps) => {
  return (
    <ResourceBaseTreeStoreProvider
      data={data}
      defaultExpandAll={defaultExpandAll}
    >
      <ResourceBaseTreeCore {...treeCoreProps} />
    </ResourceBaseTreeStoreProvider>
  )
}
